import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=77e500c0&"
import script from "./Empty.vue?vue&type=script&lang=ts&"
export * from "./Empty.vue?vue&type=script&lang=ts&"
import style0 from "./Empty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports